(function () {
    "use strict";

    var app = angular.module('typeahead', []);

    app.directive('typeAhead', ['$log', '$timeout', function ($log, $timeout) {
        return {
            restrict: 'E',
            scope: {
                data: '=',
                delay: "=?",
                forceSelection: "=?",
                limit: '=?',
                startFilter: "=?",
                threshold: '=?',
                onBlur: "=?",
                onSelect: '=?',
                onType: "=?"
            },
            require: "?ngModel",
            transclude: true,
            link: function (scope, elem, attrs, ngModel) {
                var KEY, itemSelected, selectedLabel, selecting;
                KEY = {
                    UP: 38,
                    DOWN: 40,
                    ENTER: 13,
                    TAB: 9,
                    ESC: 27
                };
                selectedLabel = scope.search;
                selecting = void 0;
                itemSelected = false;
                scope.index = 0;
                if (!scope.delay) {
                    scope.delay = 0;
                }
                scope.placeholder = attrs.placeholder;
                if (scope.startFilter === void 0) {
                    scope.startFilter = true;
                }
                if (scope.limit === void 0) {
                    scope.limit = Infinity;
                }
                if (scope.threshold === void 0) {
                    scope.threshold = 0;
                }
                if (scope.forceSelection === void 0) {
                    scope.forceSelection = false;
                }
                scope.$watch("search", function (v) {
                    scope.index = 0;
                    ngModel.$setViewValue(v);
                    if (v === selectedLabel) {
                        return;
                    }
                    itemSelected = false;
                    if (v !== void 0) {
                        if (scope.onType) {
                            scope.onType(scope.search);
                        }
                        scope.showSuggestions = scope.suggestions.length && scope.search && scope.search.length > scope.threshold;
                        return scope.showSuggestions;
                    }
                });
                scope.$onBlur = function () {
                    if (!itemSelected && scope.forceSelection) {
                        scope.search = selectedLabel;
                    }
                    scope.showSuggestions = false;
                    return scope.showSuggestions;
                };
                scope.$onSelect = function (item) {
                    if (!item) {
                        return;
                    }
                    selecting = true;
                    selectedLabel = item.label;
                    scope.search = item.label;
                    itemSelected = true;
                    if (scope.onSelect) {
                        scope.onSelect(item);
                    }
                    scope.showSuggestions = false;
                    return $timeout(function () {
                        selecting = false;
                        return selecting;
                    });
                };
                scope.$onKeyDown = function (event) {
                    switch (event.keyCode) {
                        case KEY.UP:
                            if (scope.index > 0) {
                                return scope.index--;
                            } else {
                                scope.index = scope.suggestions.length - 1;
                                return scope.index;
                            }
                            break;
                        case KEY.DOWN:
                            if (scope.index < (scope.suggestions.length - 1)) {
                                return scope.index++;
                            } else {
                                scope.index = 0;
                                return scope.index;
                            }
                            break;
                        case KEY.ENTER:
                            return scope.$onSelect(scope.suggestions[scope.index]);
                        case KEY.TAB:
                            return scope.$onSelect(scope.suggestions[scope.index]);
                        case KEY.ESC:
                            scope.showSuggestions = false;
                            return scope.showSuggestions;
                    }
                };
                return scope.$onKeyDown;
            },
            template: require('../Templates/typeahead.html').default
        };
    }]);

    app.filter("startsWith", ['$log', function ($log) {
        var strStartsWith = function (suggestion, search) {
            if (!!suggestion && !!search) {
                return suggestion.toLowerCase().indexOf(search.toLowerCase()) !== -1;
            }
        };
        return function (suggestions, search, startFilter) {
            var filtered;
            if (startFilter) {
                filtered = [];
                angular.forEach(suggestions, function (suggestion) {
                    if (strStartsWith(suggestion.label, search)) {
                        return filtered.push(suggestion);
                    }
                });
                return filtered;
            } else {
                return suggestions;
            }
        };
    }]);

    app.filter("highlight", ['$sce', function ($sce) {
        return function (item, search) {
            angular.forEach(item, function (input) {
                var exp, highlightedInput, normalInput, words;
                if (search) {
                    words = "(" + search.split(/\ /).join(" |") + "|" + search.split(/\ /).join("|") + ")";
                    exp = new RegExp(words, "gi");
                    normalInput = input.label.slice(search.length);
                    if (words.length) {
                        highlightedInput = input.label.slice(0, search.length).replace(exp, "<span class=\"ng-typeahead-highlight\">$1</span>");
                    }
                    input.html = $sce.trustAsHtml(highlightedInput + normalInput);
                    return input.html;
                }
            });
            return item;
        };
    }]);
}());
